import React from "react";
import heroBg from "../Images/Successbackground.jpg";
import "../AchievementsComponent/AchievementsComponentCss/SuccessStorySection.css";
export default function SuccessStorySection() {
  return (
    <section
      className="success-hero-wrapper"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <div className="success-hero-overlay"></div>

      <div className="success-hero-content">
        <h1 className="success-hero-title">यशोगाथा </h1>

        <p className="success-hero-text">
         नागठाणेे जिल्हा परिषद प्राथमिक शाळेतील विद्यार्थ्यांनी टॅबलेट आणि स्मार्ट टीव्हीद्वारे ई-लर्निंग सुरू केल्यानंतर शैक्षणिक प्रगतीत लक्षणीय वाढ झाली.
        </p>
      </div>
    </section>
  );
}
